import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
const styles = (theme) => {
	//const primaryColor = theme.palette.primary[500];
	return {
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign : 'left',
			boxSizing: 'border-box',
			padding : 20,
			[theme.breakpoints.up('md')]: {
				padding : '20px 30px 30px 30px',
			}
		},
	};
};

class PrivacyPolicy extends Component {
	render() {
		const {classes} = this.props;
		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Paper className={classes.paper}>
						<h2>
							Privacy Policy
						</h2>

						<p>
							Your privacy is very important to us. Accordingly, we have developed this Policy in order for you to understand how we collect, use, communicate and disclose and make use of personal information. The following outlines our privacy policy.
						</p>

						<ul>
							<li>
								Before or at the time of collecting personal information, we will identify the purposes for which information is being collected.
							</li>
							<li>
								We will collect and use of personal information solely with the objective of fulfilling those purposes specified by us and for other compatible purposes, unless we obtain the consent of the individual concerned or as required by law.
							</li>
							<li>
								We will only retain personal information as long as necessary for the fulfillment of those purposes.
							</li>
							<li>
								We will collect personal information by lawful and fair means and, where appropriate, with the knowledge or consent of the individual concerned.
							</li>
							<li>
								Personal data should be relevant to the purposes for which it is to be used, and, to the extent necessary for those purposes, should be accurate, complete, and up-to-date.
							</li>
							<li>
								We will protect personal information by reasonable security safeguards against loss or theft, as well as unauthorized access, disclosure, copying, use or modification.
							</li>
							<li>
								We will make readily available to customers information about our policies and practices relating to the management of personal information.
							</li>
						</ul>

						<p>
							We are committed to conducting our business in accordance with these principles in order to ensure that the confidentiality of personal information is protected and maintained.
						</p>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

PrivacyPolicy.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
])(PrivacyPolicy);

